import { AUDIO_CONFIG } from "./config";
import { ProceduralAmbientEngine } from "./proceduralEngine";
import { FileAmbientEngine } from "./fileEngine";

/**
 * Engine factory (singleton).
 *
 * Picks the right ambient engine based on audio/config.js:
 *   • ambientSrc set  → FileAmbientEngine  (your produced soundscape)
 *   • ambientSrc null → ProceduralAmbientEngine (built-in placeholder)
 *
 * Every engine implements the same interface — fadeIn / fadeOut / playChime —
 * so nothing else in the app needs to change when you swap the source.
 *
 * The singleton survives React StrictMode double-mounts.
 */
let engine = null;

export const getAmbientEngine = () => {
  if (!engine) {
    engine = AUDIO_CONFIG.ambientSrc
      ? new FileAmbientEngine(AUDIO_CONFIG)
      : new ProceduralAmbientEngine();
  }
  return engine;
};

export { AUDIO_CONFIG };
